import { defineStore } from 'pinia'
import { ref } from 'vue'

import { Cef, Request } from '@/modules/trips/interfaces/cef'

export const useCefStore = defineStore('cef', () => {
	const cef = ref<Cef>()
	const tabsReferences = ref<string[]>([])
	const requestHotel = ref<Request>()
	const requestPlane = ref<Request>()
	const requestBus = ref<Request>()
	const requestCar = ref<Request>()
	const requests = ref<Request[]>([])

	return {
		cef,
		tabsReferences,
		requestBus,
		requestCar,
		requestHotel,
		requestPlane,
		requests,

		//Actions
		setCef(newCef: Cef) {
			cef.value = newCef
		},
		clearRequests() {
			requestHotel.value = undefined
			requestPlane.value = undefined
			requestBus.value = undefined
			requestCar.value = undefined
		},

		setRequests(newRequests: Request[]) {
			requests.value = newRequests
		},

		reset() {
			requests.value = []
			requestHotel.value = undefined
			requestPlane.value = undefined
			requestBus.value = undefined
			requestCar.value = undefined
			cef.value = undefined
		},
	}
})
